import { AuthContext } from "../components/AuthProvider.js";
import { useContext } from "react";

//#region src/client/hooks/use-auth-context.ts
const useAuthContext = () => {
	const ctx = useContext(AuthContext);
	if (ctx === null) throw new Error("useAuthContext() cannot be called outside of an AuthProvider");
	return ctx;
};

//#endregion
export { useAuthContext };